import React, { useState } from "react";
import OrderProductTable from "./OrderProductTable";

interface Product {
    id: number;
    order_id: number;
    discount_price: number | null;
    status: number | null;
    quantity_product: number;
    name_product: string;
    slug_product: string;
    avatar_product: string;
    price_product: number;
}

interface MyOrderDetailListProductProps {
    products: Product[];
    total: number;
}

export default function MyOrderDetailListProduct({ products, total }: MyOrderDetailListProductProps) {

    return (
        <div className="MuiGrid-root styles_table_wrapper__bJ_CM MuiGrid-item MuiGrid-grid-xs-12">
            <div className="MuiGrid-root styles_table__2_Acb MuiGrid-container MuiGrid-item MuiGrid-grid-xs-12">
                <div className="MuiGrid-root MuiGrid-container MuiGrid-item MuiGrid-justify-content-xs-space-between MuiGrid-grid-xs-12">
                    <p className="styles_title_list__67DiS">Danh sách sản phẩm ({products.length} sản phẩm)</p>
                </div>
                <OrderProductTable products={products} />
                <div className="MuiGrid-root styles_dashed__CDiXX styles_bottomListProduct__p4Gnw MuiGrid-item MuiGrid-grid-xs-12"></div>

                {/* total */}
                <div
                    className="MuiGrid-root MuiGrid-container MuiGrid-item MuiGrid-grid-xs-12"
                    style={{ marginTop: "20px" }}
                >
                    <div className="MuiGrid-root MuiGrid-container MuiGrid-item MuiGrid-grid-xs-12">
                        <div className="MuiGrid-root styles_bottomPrice__C9gx6 MuiGrid-item MuiGrid-grid-xs-10">
                            <p className="MuiTypography-root MuiTypography-body1">Tạm tính</p>
                        </div>
                        <div className="MuiGrid-root styles_bottomPriceRight__PgCQH MuiGrid-item MuiGrid-grid-xs-2">
                            <p className="MuiTypography-root MuiTypography-body1">{total?.toLocaleString()}đ</p>
                        </div>


                        <div className="MuiGrid-root styles_bottomPrice__C9gx6 MuiGrid-item MuiGrid-grid-xs-10">
                            <p className="MuiTypography-root MuiTypography-body1">
                                Phí vận chuyển
                            </p>
                        </div>
                        <div className="MuiGrid-root styles_bottomPriceRight__PgCQH MuiGrid-item MuiGrid-grid-xs-2">
                            <p className="MuiTypography-root MuiTypography-body1">0</p>
                        </div>

                        <div className="MuiGrid-root styles_bottomPrice__C9gx6 MuiGrid-item MuiGrid-grid-xs-10">
                            <p className="MuiTypography-root MuiTypography-body1">Phụ phí</p>
                        </div>
                        <div className="MuiGrid-root styles_bottomPriceRight__PgCQH MuiGrid-item MuiGrid-grid-xs-2">
                            <p className="MuiTypography-root MuiTypography-body1">0</p>
                        </div>

                        <div className="MuiGrid-root styles_bottomPrice__C9gx6 MuiGrid-item MuiGrid-grid-xs-10">
                            <p className="MuiTypography-root MuiTypography-body1">
                                Phí tiện ích
                            </p>
                            <p className="MuiTypography-root styles_bottomPriceSubtitle__C7Na6 MuiTypography-body1"></p>
                        </div>
                        <div className="MuiGrid-root styles_bottomPriceRight__PgCQH MuiGrid-item MuiGrid-grid-xs-2">
                            <p className="MuiTypography-root MuiTypography-body1">0</p>
                        </div>

                        <div
                            className="MuiGrid-root styles_dashed__CDiXX MuiGrid-item MuiGrid-grid-xs-12"
                            style={{ marginTop: "0px" }}
                        />

                        <div className="MuiGrid-root styles_promoCodeTop__vhrIA MuiGrid-item MuiGrid-grid-xs-10">
                            <p className="MuiTypography-root MuiTypography-body1">
                                Giảm theo hình thức thanh toán
                            </p>
                        </div>
                        <div className="MuiGrid-root styles_promoCodeRightTop__bcRtr MuiGrid-item MuiGrid-grid-xs-2">
                            <p className="MuiTypography-root MuiTypography-body1">0</p>
                        </div>

                        {/* <div className="MuiGrid-root styles_promoCodeTop__vhrIA MuiGrid-item MuiGrid-grid-xs-12">
                            <p className="MuiTypography-root MuiTypography-body1">Giảm giá</p>
                        </div>

                        <div className="MuiBox-root css-1jio8u9">
                            <p className="MuiTypography-root styles_newPromoCode__Odavh MuiTypography-body1">
                                CHUYENKHOAN2601
                            </p>
                            <span className="styles_newPromoCodeRight__ZjrrX">-12.100</span>
                        </div> */}
                    </div>

                    <div className="MuiGrid-root styles_dashed__CDiXX MuiGrid-item MuiGrid-grid-xs-12" />

                    <div className="MuiGrid-root styles_totalPrice__wNFOG MuiGrid-container MuiGrid-item MuiGrid-align-items-xs-center MuiGrid-justify-content-xs-space-between MuiGrid-grid-xs-12">
                        <div className="MuiGrid-root styles_price_point__MVCRM MuiGrid-item">
                            <p className="MuiTypography-root MuiTypography-body1">
                                Tổng điểm tích lũy
                            </p>
                        </div>
                        <div className="MuiGrid-root styles_pricePoint__aaTuk MuiGrid-item">
                            0
                        </div>
                    </div>

                    <div className="MuiGrid-root styles_totalPrice__wNFOG MuiGrid-container MuiGrid-item MuiGrid-align-items-xs-center MuiGrid-justify-content-xs-space-between MuiGrid-grid-xs-12">
                        <div className="MuiGrid-root styles_price_label__aj6A0 MuiGrid-item">
                            <p className="MuiTypography-root MuiTypography-body1">Tổng tiền</p>
                        </div>
                        <div className="MuiGrid-root styles_price___bg9n MuiGrid-item">
                            {total?.toLocaleString()}đ
                        </div>
                    </div>

                    <div className="MuiGrid-root styles_groupActionBtn__7_FZq MuiGrid-container MuiGrid-item MuiGrid-align-items-xs-center MuiGrid-justify-content-xs-center MuiGrid-grid-xs-12">
                        <div className="MuiGrid-root styles_disableBtn__AXJMP MuiGrid-container MuiGrid-item MuiGrid-justify-content-xs-center MuiGrid-grid-sm-4">
                            <button
                                className="MuiButtonBase-root MuiButton-root MuiButton-text jss197 jss200 styles_btnRequestCancel__TYfBm styles_disableBtn__AXJMP Mui-disabled Mui-disabled"
                                tabIndex={-1}
                                type="button"
                                disabled
                            >
                                <span className="MuiButton-label">Yêu cầu hủy đơn</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
